import tw from "twin.macro"

import { H1, H5, P } from "../Styled/Text"

export const Body = tw.div`lg:px-10`
export const Content = tw.section`bg-white py-8 md:py-19`
export const Title = tw(H1)`text-2xl`
export const IconWrapper = tw.div`mt-2 md:mt-4`
export const NextTitle = tw(P)`leading-normal md:leading-none`
export const NextHeading = tw(H5)`text-lg`
export const Next = tw.div`block px-6.5 py-5.5 text-teal-lighter rounded-xl bg-navy hover:bg-teal-dark hover:text-white transition-colors duration-200 cursor-pointer`
